import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API, CONST_ONE_API, US_ORIGIN } from '../constants';
import { environment } from 'src/environments/environment';
import { CommanSubscribeService } from '../services/comman-subscribe.service';
import { StorageService } from '../services/storage.service';

@Injectable()
export class AreveaTVInterceptor implements HttpInterceptor {

    SKIP_URLS: string[];
    CONCAT_URL: string[];
    OL_AuthURLs : any = [];
    constructor(private commanSubscribeService: CommanSubscribeService,
        private storageService : StorageService) {
        this.SKIP_URLS = [API.VENDOR_REGISTER, API.USER_REGISTER, API.USER_LOGIN,
        API.GET_PAYMENT_DETAILS,
        API.VERIFY_CAPTCHA, API.GET_SUBSCRIPTION_PLANS, CONST_ONE_API.API_SESSION_TOKEN];
        this.CONCAT_URL = [];
        this.SKIP_URLS.forEach(e => {
            if(e==CONST_ONE_API.API_SESSION_TOKEN) {
                this.CONCAT_URL.push(environment.oneLogin.subDomainURL + e);
            } else {
                this.CONCAT_URL.push(environment.API_URL_TV + e);
            }            
        });

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let userInfo = this.commanSubscribeService.userInfo;
        let rawPubnubKeys = this.commanSubscribeService.pubnubKeyset?.value;
        let pubnubkeys: any = {}
        if (typeof rawPubnubKeys === 'string') {
            try {
            pubnubkeys = JSON.parse(rawPubnubKeys);
            } catch (e) {
            console.error('Failed to parse pubnubKeyset string in interceptor:', e);
            }
        } else if (typeof rawPubnubKeys === 'object') {
            pubnubkeys = rawPubnubKeys;
        }
        let ol_authInfo = this.storageService.getItem("ol_authInfo");
        console.log("pubnubkeys=========", pubnubkeys);
        const validPubnubKeys = pubnubkeys?.pubnub_publish_key && pubnubkeys?.pubnub_subscribe_key;
        const pubnubHeaders = validPubnubKeys ? {
            'pubnub-publish-key': pubnubkeys.pubnub_publish_key,
            'pubnub-subscribe-key': pubnubkeys.pubnub_subscribe_key,
        } : {};
        let clonedRequest = req;
            if (this.checkURLs(req.url) && ol_authInfo && ol_authInfo.access_token) {

            const Request: HttpRequest<any> = req.clone({
                setHeaders: {
                "Authorization": `Bearer ${ol_authInfo.access_token}`,
                "Content-Type": "application/json",
                ...pubnubHeaders
                }
            });
            return next.handle(Request);
            } else if (!this.isURLSkippable(req.url) && userInfo && userInfo.access_token) {
            const Request: HttpRequest<any> = req.clone({
                setHeaders: {
                "Authorization": `Bearer ${userInfo.access_token}`,
                "access_token": userInfo.access_token,
                "x-api-key": environment.AWS_Cognito.X_Api_Key,
                ...pubnubHeaders
                }
            });
            return next.handle(Request);
            } else {
                // Default case: not skippable, no tokens, but still send pubnub headers if any
                clonedRequest = req.clone({
                  setHeaders: {
                    ...pubnubHeaders
                  }
                });
              }
            return next.handle(clonedRequest);

    }

    checkURLs(url){
        let returnValue = false;
        this.OL_AuthURLs.forEach(e => {
          if(url.indexOf(e) != -1)
          returnValue = true;
        });
        return returnValue;
    }

    //here checking is api auth token required or not
    private isURLSkippable(requestURL: string): boolean {
        requestURL = requestURL || "";
        if (requestURL.indexOf(environment.AWS.SignedURLBase) > -1 || requestURL.indexOf('amazonaws.com') != -1) {
            return true;
        } else if (requestURL.indexOf('ipfs.io') != -1) {
            return true
        } else if (requestURL.indexOf('admin.traffiq.bigbee.ai') != -1) {
            return true
        // } else if (requestURL.indexOf('/api/v1') != -1) {
        //     return true
        } else {
            return this.CONCAT_URL.some(e => requestURL.indexOf(e) > -1);
        }
    }
}

